// xgen-init.js
(() => {
  const MIGRATION_VERSION = window.__XGEN_CONFIG?.version ?? 'v2';
  const COOKIE_RESET_VERSION =
    window.__XGEN_CONFIG?.cookieResetVersion ?? '1';
  const CONFIG_SIGNATURE_STORAGE_KEY =
    `xgen_config_signature_${MIGRATION_VERSION}`;
  const COOKIE_RESET_STORAGE_KEY =
    `xgen_cookie_reset_${MIGRATION_VERSION}`;
  const config = {
    key: '5dd7f56420a65f1ef543157da89554f0',
    secret: '7d6c40a22ddaf648c742af4d4225e198e3a61e847e6437646146353965d65ccb186f026a0f3fb21d9af40a5bf02233a2d2c326c2cd54f7b646cadd22d6b60603',
    clientId: 'f179680e0517a0918900eeb95a088f1f',
    trackerId: '6185efb5de6d4a1b99b0d11f6c166d04',
    locale: 'en_US',
  };

  const XGEN_COOKIE_NAMES = ['xgen_user', 'xgen_session', 'xgen_token'];

  const getConfigSignature = () => {
    const raw = [config.key, config.clientId, config.trackerId, config.locale].join('|');
    let hash = 2166136261;
    for (let i = 0; i < raw.length; i += 1) {
      hash ^= raw.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return `${MIGRATION_VERSION}_${(hash >>> 0).toString(16).padStart(8, '0')}`;
  };

  const getStoredConfigSignature = () => {
    try {
      return (
        localStorage.getItem(CONFIG_SIGNATURE_STORAGE_KEY) ||
        sessionStorage.getItem(CONFIG_SIGNATURE_STORAGE_KEY)
      );
    } catch {
      return null;
    }
  };

  const setStoredConfigSignature = (signature) => {
    try {
      localStorage.setItem(CONFIG_SIGNATURE_STORAGE_KEY, signature);
    } catch {
      try {
        sessionStorage.setItem(CONFIG_SIGNATURE_STORAGE_KEY, signature);
      } catch { /* ignore */ }
    }
  };

  const getStoredCookieResetVersion = () => {
    try {
      return (
        localStorage.getItem(COOKIE_RESET_STORAGE_KEY) ||
        sessionStorage.getItem(COOKIE_RESET_STORAGE_KEY)
      );
    } catch {
      return null;
    }
  };

  const setStoredCookieResetVersion = (version) => {
    try {
      localStorage.setItem(COOKIE_RESET_STORAGE_KEY, version);
    } catch {
      try {
        sessionStorage.setItem(COOKIE_RESET_STORAGE_KEY, version);
      } catch { /* ignore */ }
    }
  };

  const expireCookie = (name, path, domain) => {
    const base = `${name}=; Max-Age=0; path=${path}`;
    const same = '; SameSite=Lax';
    const secure = typeof location !== 'undefined' && location.protocol === 'https:' ? '; Secure' : '';
    if (domain) {
      document.cookie = `${base}; domain=${domain}${same}${secure}`;
    } else {
      document.cookie = `${base}${same}${secure}`;
    }
  };

  const clearLegacyXgenCookies = () => {
    const path = '/';
    const host = typeof location !== 'undefined' ? location.hostname : '';
    const parts = host.split('.').filter(Boolean);
    const parent = parts.length > 1 ? `.${parts.slice(-2).join('.')}` : '';
    const domains = new Set();
    if (host) {
      domains.add(host);
      if (parent) domains.add(parent);
      domains.add(`.${host}`);
    }
    for (const name of XGEN_COOKIE_NAMES) {
      expireCookie(name, path, undefined);
      for (const domain of domains) {
        expireCookie(name, path, domain);
      }
    }
  };

  // One-time cookie reset for all returning users when cookieResetVersion bumps.
  const syncCookiesWithCurrentConfig = () => {
    const currentSignature = getConfigSignature();
    const storedSignature = getStoredConfigSignature();
    const storedResetVersion = getStoredCookieResetVersion();
    const migrationResetNeeded = storedResetVersion !== COOKIE_RESET_VERSION;
    const configChanged = storedSignature && storedSignature !== currentSignature;

    if (migrationResetNeeded || configChanged) {
      console.log(
        migrationResetNeeded
          ? '[XGEN] Cookie reset version changed, clearing XGen cookies for new customer.'
          : '[XGEN] Config changed, clearing XGen cookies.'
      );
      clearLegacyXgenCookies();
    }

    setStoredCookieResetVersion(COOKIE_RESET_VERSION);
    setStoredConfigSignature(currentSignature);
  };

  syncCookiesWithCurrentConfig();

  const initSdk = () => {
    if (!window.XGenSdkCore?.XGenClient) {
      setTimeout(initSdk, 50);
      return;
    }

    try {
      const { XGenClient } = window.XGenSdkCore;
      window.xgenClient = new XGenClient(config);
      document.dispatchEvent(new Event('xgen-ready'));
    } catch (err) {
      console.error('Init Error:', err);
    }
  };

  initSdk();
})();